import { useQuery } from '@tanstack/react-query';
import type { WebappResponse } from '@eventbrite/event-listing-service-client';

import { fetchFreshEventContext } from '@/src/listings/utils/fetchFreshEventContext';

export const EDITOR_CONTEXT_QUERY_KEY = 'editor-event-context';

type UseEditorContextRefreshArgs = {
  eventId: string | undefined;
  enabled: boolean;
};

export function useEditorContextRefresh({ eventId, enabled }: UseEditorContextRefreshArgs) {
  return useQuery<WebappResponse | null>({
    queryKey: [EDITOR_CONTEXT_QUERY_KEY, eventId],
    queryFn: async () => {
      if (!eventId) {
        return null;
      }
      return fetchFreshEventContext(eventId);
    },
    enabled,
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
